import * as moment from 'moment';
import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { StoreInvoice } from '../../../core/shared/model/StoreInvoice';
import { Parent } from '../../../core/shared/model/Parent';
import { UserService } from '../../../core/services/user.service';
import { NavigationExtras, Router } from '@angular/router';
import { GridComponent, PageChangeEvent, RowArgs, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import { DialogType, FSInvoiceDialogService } from "../../../core/services/fsinvoice.dialog.service";
import { ExcelService } from '../../../core/services/excel.service';
import { ReportParams } from '../../../core/shared/model/ReportParams';
import { InvoicesService } from '../../../core/services/invoices.service';
import { Invoice } from "../../../core/shared/model/Invoice";
import { InvoiceStore } from "../../../core/shared/model/InvoiceStore";
import { FormGroup } from '@angular/forms';
import { DownloadDialogComponent}  from "~/app/web/invoices/downloadDialog/download-dialog.component";
import { DownloadRequest } from "@model/DownloadRequest";
import { downloadIcon } from "@progress/kendo-svg-icons";
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';
import { EMPTY, from, map, mergeMap, Observable, tap, lastValueFrom, take, pipe, catchError, of, finalize, Subscription } from 'rxjs';
import { OnBaseService } from '~/app/core/services/onbase.service';
import { PDFDocument } from 'pdf-lib';
import { InvoiceDocument, InvoiceDocumentResult } from '~/app/core/reports/models/invoice-document';
import { HttpDownloadProgressEvent, HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';


@Component({
  selector: 'app-invoices-invoices',
  templateUrl: './invoices-invoices.component.html',
  styleUrls: ['./invoices-invoices.component.scss'],
  providers: [ExcelService]
})
export class InvoicesInvoicesComponent implements OnInit {
  readonly SELECTION_LIMIT: number = 500;
  readonly SELECTION_ERROR_MESSAGE: string = `You have reached the limit of selected rows. Please select up to ${this.SELECTION_LIMIT} rows or select all rows.`;
  readonly SELECTION_DISABLE_BULK_MESSAGE: string = `All Records must be selected to use Bulk Select Mode, press 'Confirm' to turn off Bulk Select Mode.`;
  readonly SELECTION_ERROR_TITLE: string = "Selection limit reached";
  readonly SELECTION_DISABLE_BULK_TITLE: string = "Disable Bulk Select Mode?";

  @ViewChild(GridComponent) private invoicesGrid: GridComponent;

  stores: Array<InvoiceStore>;
  selectedStores: string[];
  data: any;
  dateRangeChk: boolean = false;
  fromDate: string;
  endDate: string;
  selectForm: FormGroup;
  selectedRequestType: string;
  selectedDateType: string;
  selectedInvType: string;
  selectedStartDate: Date;
  selectedEndDate: Date = moment().toDate();
  requestDownload: DownloadRequest = new DownloadRequest();
  reportParams: Array<ReportParams> = new Array<ReportParams>();
  storeMap: Map<string, Invoice> = new Map<string, Invoice>();
  selectedInvoices: Array<Invoice> = new Array<Invoice>();
  selectedParentsMap: Map<string, Parent> = new Map<string, Parent>();
  selectedParents: Array<string> = new Array<string>();
  selectedInvoicesMap: Map<string, Invoice> = new Map<string, Invoice>();
  selectedStoreInvoicesMap: Map<string, StoreInvoice> = new Map<string, StoreInvoice>();
  userName: string;
  selectedKeys: string[];
  downloaded: boolean = false;
  download: string;
  pageSize: number = 30;
  skip = 0;
  info = true;
  buttonCount = 5;
  type: 'numeric';
  pageSizes: number[] = [20, 40, 60];
  previousNext = true;
  selectAllState: SelectAllCheckboxState = 'unchecked';
  previousDisabled: boolean = false;
  nextDisabled: boolean = false;
  loading: any;
  fromRange: string;
  toRange: string;
  invoices: Array<Invoice> = new Array<Invoice>();
  response: any;
  pdfURL: string;
  missing: string;
  pdf: string;
  masterSelect = false;
  invoicesString: string[];
  newStores: string[] = [];
  newParents: string[];
  opened: boolean = false;
  viewInvoiceModalOpen: boolean = false;
  viewInvoiceReady: boolean = false;
  bulk: boolean = false;
  foundNoInvoices: boolean = false;
  minDateStart: Date = moment().subtract(18, 'months').toDate();
  invoiceViewResults: InvoiceDocumentResult;
  displayInvoices: (InvoiceDocument| null)[] = [];
  viewInvoiceSubscription?: Subscription;
  invoiceLoadTime: number = 0;
  elapsedDisplay: string;
  startTime: number;
  elapsedTime: number;
  requestInProgress: boolean;
  private timer: ReturnType<typeof setInterval> | null = null;


  protected readonly downloadIcon = downloadIcon;

  sort: SortDescriptor[] = [{
    field: 'invoiceNumber',
    dir: 'asc'
  }];

  constructor(private _userService: UserService, 
              public invoiceService: InvoicesService,
              public excelService: ExcelService,
              private _router: Router,
              public fsInvoiceDialog: FSInvoiceDialogService,
              public loadingIndicator: LoadingIndicatorHelper,
              public onbase: OnBaseService,
              public zone: NgZone) {
    this.selectedKeys = [];
  }

  get outsideDownloadRange() {
    return this.selectedStartDate < this.minDateStart;
  }

  get selectionLimitString(): string {
    return `(${this.selectedKeys.length}/${this.SELECTION_LIMIT} rows)`
  }

  get masterSelectState(): string {
    return this.selectedKeys.length === 0 ? 'unchecked' : this.isAllSelected ? 'checked' : 'indeterminate'
  }

  get isAllSelected(): boolean {
    return this.invoices.length === this.selectedKeys.length
  }

  get isValidSelection(): boolean {
    return (this.selectedKeys.length <= this.SELECTION_LIMIT && this.selectedKeys.length > 0);
  }

  get isValidState(): boolean {
    return (this.selectedStores !== undefined && this.selectedParents !== undefined) && 
      (this.selectedStores.length > 0 && this.selectedParents.length > 0);
  }

  get canView(): boolean {
    return (this.isValidSelection && !this.loading);
  }

  ngOnInit() {
    this.loadingIndicator.show();
    this.bulk = this._userService.getBulkSelect();
    this.masterSelect = false;
    this.selectedInvoicesMap = this._userService.getSelectedInvoicesMapInvoice();
    this.selectedStartDate = moment(this._userService.getSelectedStartDateInvoice()).toDate();
    this.selectedEndDate = moment(this._userService.getSelectedEndDateInvoice()).toDate();
    this.selectedInvType = this._userService.getSelectedInvTypeInvoice();
    this.selectedRequestType = this._userService.getSelectedRequestTypeInvoice();
    this.selectedDateType = this._userService.getSelectedDateType();
    this.userName = this._userService.getUserName();
    this.fromDate = moment(this.selectedStartDate).format('YYYY-MM-DD');
    this.endDate = moment(this.selectedEndDate).format('YYYY-MM-DD');
    this.selectedParents = this._userService.getSelectedInvoiceParents();
    this.selectedStores = this._userService.getSelectedInvoiceStores();
    this.fromRange = this._userService.getFromRange();
    this.toRange = this._userService.getToRange();
    this.downloaded = this._userService.getDownloaded();
    
    if (!this.isValidState) {
      this._router.navigate(['/invoices']);
    } else {
      let invoices$ = new Observable<Invoice[]>();
      if (this.selectedRequestType != 'D') {
        invoices$ = this.invoiceService.getInvoicesSummary(this.selectedParents, 
                                                            this.selectedStores, 
                                                            this.selectedRequestType, 
                                                            this.downloaded, 
                                                            this.fromRange, 
                                                            this.toRange, 
                                                            this.fromDate, 
                                                            this.endDate);
      } else {
        invoices$ = this.invoiceService.getInvoiceSummaryDate(this.selectedParents, 
                                                              this.selectedStores, 
                                                              this.selectedInvType,
                                                              this.downloaded, 
                                                              this.fromDate, 
                                                              this.endDate);
      }

      invoices$.pipe(
        tap((invoices: Invoice[]) => {
          this.loadingIndicator.hide();
          this.invoices = invoices;
          if (invoices === undefined || invoices.length === 0) {
            this.foundNoInvoices = true;
          }
        }),
        mergeMap((invoices: Invoice[]) => {
          if (this.masterSelect === true) {
            this.selectAllState = 'checked';
            this.selectedKeys = [];
            this.selectedInvoicesMap = new Map<string, Invoice>();
            return from(invoices).pipe(
              map((invoice: Invoice) => {
                this.selectedKeys.push(invoice.invoiceNumber);
                this.selectedInvoicesMap.set(invoice.invoiceNumber, invoice);
              }))
          }
          return EMPTY;
       })).subscribe();
    }
  }

  ngOnDestroy() {
    this.clearTimer();
  }

  backClicked() {
    //this._userService.setSelectedInvoices(this.selectedKeys);
    let navigationExtras: NavigationExtras = {
      queryParams: {}
    };
    this._router.navigate(['/invoicesearch'], navigationExtras);
  }

  pageChange({skip, take}: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

  isRowSelected = (e: RowArgs) => this.selectedKeys.includes(e.dataItem.invoiceNumber);

  allRowsSelected(selectionObj: any) {
    this.selectedKeys = [];
    this.selectedInvoicesMap.clear();
    if (selectionObj === 'checked' && this.masterSelect === false) {
      this.masterSelect = true;

      /* This needs to be refactored, the selections are random and do not abide by the kendo logic. */
      from(this.invoices).pipe(
        take(this.SELECTION_LIMIT),
        tap(item => {
          this.newStores[0] = this.newStores[0] ? `${this.newStores[0]},${item.customer}` : item.customer;
          this.selectedKeys.push(item.invoiceNumber);
          this.selectedInvoicesMap.set(item.invoiceNumber, item);
        })
      ).subscribe();
    } else {
      this.masterSelect = false;
    }
    this.selectAllState = selectionObj;
    this.invoiceService.setMasterInvoiceSelect(this.masterSelect);
    this._userService.setSelectedInvoicesMapInvoice(this.selectedInvoicesMap);
  }

  selectionChanged(selectionObj: any) {
    selectionObj.deselectedRows.forEach(row => {
      const index = this.selectedKeys.indexOf(row.dataItem.invoiceNumber);
      if (index !== -1) {
        this.selectedKeys.splice(index, 1);
        this.rowCheckBoxChanged(false, row.dataItem);
      }
    });

    let selectionLimitErrorShown = false; // So we only show the dialog once.
    // Only show the error message to the user if they have selected a row by hand.
    // If they have selected the "Page" or "All Records" checkboxes, it is simpler to just sanitize.
    let shouldShowError = selectionObj.selectedRows?.length === 1;

    selectionObj.selectedRows.forEach(row => {
      if (!this.selectedKeys.includes(row.dataItem.invoiceNumber)) {
        if (this.selectedKeys.length < this.SELECTION_LIMIT) {
          this.selectedKeys.push(row.dataItem.invoiceNumber);
          this.rowCheckBoxChanged(true, row.dataItem);
        } else {
          if (selectionLimitErrorShown === false && shouldShowError) {
            selectionLimitErrorShown = true; 
            this.fsInvoiceDialog.openDialog(
              {
                type: DialogType.WARNING,
                title: this.SELECTION_ERROR_TITLE,
                content: this.SELECTION_ERROR_MESSAGE,
                actions: [
                  {text: 'Confirm', primary: true}
                ],
                width: 400
              }).then();
            }
        }
      }
    });
  }

  rowCheckBoxChanged(checked: boolean, store: Invoice) {
    if (checked) {
      this.selectedInvoicesMap.set(store.storeNumber, store);
    } else {
      this.selectedInvoicesMap.delete(store.storeNumber);
    }
  }

  selectionKey(context: RowArgs): string {
    return context.dataItem;
  }

  keyChange(e) {
    this.newStores = [];
    e.forEach(item => {
      this.newStores.push(item.customer);
    });
    let tempStores = this.newStores.toString();
    this.newStores = [tempStores];
  }

  private startTimer() {
    this.startTime = performance.now();
    this.timer = setInterval(() => {
      const now = performance.now();
      const elapsed = now - this.startTime;
      const seconds = Math.floor(elapsed / 1000);
      const ms = Math.floor(elapsed % 1000);
      this.elapsedDisplay = `${seconds}.${ms.toString().padStart(3, '0')}s`;
    }, 100);
  }

  private clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }


  viewInvoiceOnbaseStream() {
    this.displayInvoices = this.selectedKeys.map(invoiceNumber => ({
      invoiceNumber,
      viewUrl: null,
      content: null
    }));
    this.startTimer();
    this.viewInvoiceReady = false;
    this.loading = true;
    this.invoiceViewResults = {
      documents: [],
      failedInvoices: [],
      count: 0
    };

    let chunkLength = 0;
    let buffer = '';

    this.viewInvoiceModalOpen = !this.viewInvoiceModalOpen;
    this.viewInvoiceSubscription = this.onbase.getDocPopURLByInvoiceListStream(this.selectedKeys).subscribe((event: HttpEvent<string>) => {
      if (event.type === HttpEventType.DownloadProgress) {
        const cumulative = (event as HttpDownloadProgressEvent).partialText;
        const delta = cumulative.slice(chunkLength);
        chunkLength = cumulative.length;
        buffer += delta;

        let start = 0;
        for (let i = 0; i < buffer.length; i++) {
          if (buffer[i] === '{') {
            start = i;
          } else if (buffer[i] === '}') {
            const objStr = buffer.slice(start, i + 1);
            try {
              const obj = JSON.parse(objStr);
              this.processOnBaseInvoice(obj);
            } catch (e) {
              console.error("Bad JSON chunk: ", objStr, e);
            }

            buffer = buffer.slice(i + 1);
            i = -1;
          }
        }
      } else if (event.type === HttpEventType.Response) {
        this.loading = false;
        this.viewInvoiceReady = true;
        this.clearTimer();
      }
    });
  }

  processOnBaseInvoice(invoiceJson: any) {
    let invoiceNumber = invoiceJson["invoiceNumber"];
    let data = invoiceJson["data"];
    let url = this.makeURLForBLOB(invoiceJson, data);

    let document: InvoiceDocument = {
      invoiceNumber,
      viewUrl: url,
      content: data
    };
    this.updatePartialDisplayInvoices(document);
    this.invoiceViewResults.documents = [...this.invoiceViewResults.documents, document]
  }

  makeURLForBLOB(invoiceNumber: string, byteArray: string): string {          
    let bin = window.atob(byteArray);
    let bytes = new Uint8Array(bin.length);

    for (let j = 0; j < bin.length; j++) {
      bytes[j] = bin.charCodeAt(j);
    }
    
    let pdf = new Blob([bytes.buffer], { type: "application/pdf" });
    return URL.createObjectURL(pdf);
  }

  cancelViewInvoices() {
    this.viewInvoiceModalOpen = false;
    if (this.viewInvoiceSubscription) {
      this.viewInvoiceSubscription.unsubscribe();
      this.viewInvoiceSubscription = undefined;
      this.loading = false;
      this.viewInvoiceReady = false;
    }
  }

  updatePartialDisplayInvoices(document: InvoiceDocument) {
    const index = this.displayInvoices.findIndex(
      inv => inv?.invoiceNumber?.toString() === document.invoiceNumber.toString()
    );
  
    if (index !== -1) {
      this.displayInvoices[index] = document;
    }
  
    // Force loaded invoices to appear first
    const loaded: InvoiceDocument[] = [];
    const unloaded: (InvoiceDocument | null)[] = [];
  
    for (const invoiceNumber of this.selectedKeys) {
      const entry = this.displayInvoices.find(
        d => d?.invoiceNumber?.toString() === invoiceNumber.toString()
      );
  
      if (entry && entry.viewUrl) {
        loaded.push(entry);
      } else {
        unloaded.push(entry ?? { invoiceNumber, viewUrl: null, content: null });
      }
    }
  
    this.displayInvoices = [...loaded, ...unloaded];
  }  
  
  async viewMasterPDF(): Promise<void> {
    this.loading = true;
    try {
      const mergedResult = await PDFDocument.create();
      this.startTimer()
      
      for (let inv of this.invoiceViewResults.documents) {
        const newPDF = await PDFDocument.load(inv.content);
        const pages = await mergedResult.copyPages(newPDF, newPDF.getPageIndices());
        pages.forEach(page => mergedResult.addPage(page));
      }
      let mergedBytes = await mergedResult.save();
      let binary = '';
      const bytes = new Uint8Array(mergedBytes);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }

      const blob = new Blob([mergedBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      window.open(url, '_blank');
    } catch (e) {
      console.error("Failed to merge documents: " + e);
    } finally {
      this.loading = false;
      this.clearTimer();
    }
  }

  /***
   * @deprecated This is the legacy invoice viewing code, use "viewInvoiceOnbase()" instead.
   */
  async viewInvoiceLegacy(): Promise<void> {
    if(this.selectedKeys.length > 1350) {
      this.fsInvoiceDialog.open({
        type: DialogType.ERROR,
        title: 'View',
        content: this.selectedKeys.length + ' statements are selected. Maximum 1350 statements can be viewed at a time.',
        actions: [
          {text: 'Ok', primary: true},
        ],
        width: 400
      });
    } else {
      this.loadingIndicator.show();
      await this._userService.setSelectedInvoicesMap(this.selectedStoreInvoicesMap);

      if (this.selectedKeys.length === 0) {
        this.loadingIndicator.hide();
        this.fsInvoiceDialog.showMessageDialog('Selection', 'You must make a selection');
      } else {
        await this.invoiceService.getInvoices(this.selectedKeys).subscribe(res => {
          if(!res || Object.keys(res).length === 0){
            let infoMessage='No data available for the requested resource.'
            this.fsInvoiceDialog.openDialog(
             {
               type: DialogType.ERROR,
               title: 'No Data',
               content:  infoMessage ,
               actions: [
                 {text: 'Ok', primary: true}
               ],
               width: 400
             }
            ).then(r => r);
            this.loadingIndicator.hide();
            this.selectedKeys = [];
            this.selectAllState = 'unchecked';
            return;
          }
      
          this.response = res;
          if (res === 'Maximum threshold exceeded.') {
            this.fsInvoiceDialog.showMessageDialog('Threshold Exceeded', res);
          } else if (res == null) {
            //Handle 204 no response
            this.fsInvoiceDialog.showMessageDialog('No data', 'No invoice data found');
          } else if (Array.isArray(res) && res.length === 0) { //504
            //Handle [] from the error service
          } else {
            this.response = this.response.trim();
            let s = this.response.charAt(0);

            if (s >= '0' && s <= '9') {
              this.missing = this.response;
              this.fsInvoiceDialog.showMessageDialog('Missing invoices', 'Invoices ' + this.missing + ' missing from pdf.');

            } else {
              let someString = this.response.toString();
              let index = someString.indexOf(" ");

              if (index == -1) {
                index = someString.length;
                this.pdf = someString.substr(0, index);

              } else {
                this.pdf = someString.substr(0, index);
                this.missing = someString.substr(index + 1);

                this.missing = this.missing.slice(0, -1);

                if (typeof this.pdf != 'undefined' && this.pdf) {
                  this.fsInvoiceDialog.showMessageDialog('Missing invoices', 'Invoices ' + this.missing + ' missing from pdf.');
                }
              }

              let binary_string = window.atob(this.pdf);
              let len = binary_string.length;
              let bytes = new Uint8Array(len);

              for (let i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
              }

              let file = new Blob([bytes.buffer], {type: 'application/pdf'});
              let fileURL = URL.createObjectURL(file);

              window.open(fileURL);
            }
          }
          this.loadingIndicator.hide();
        });
        this.selectedKeys = [];
        this.selectAllState = 'unchecked';
      }
    }
  }

  exportAsXLSX(): void {
    if (this.selectedKeys.length == 0) {
      this.fsInvoiceDialog.showMessageDialog('Selection', 'You must make a selection');
    } else {
      this._userService.setSelectedInvoicesMapInvoice(this.selectedInvoicesMap);
      this.selectedInvoices = new Array<Invoice>();
      this.selectedInvoicesMap.forEach((storeInvoice, iNum) => {
        this.selectedInvoices.push(storeInvoice);
      });

      let newdata = this.selectedInvoices.map(item => {
        return {
          "Invoice Number": item.invoiceNumber,
          "Order Number": item.orderNumber,
          "Invoice Type": item.invoiceType,
          "Customer Number": item.customer,
          "Store Number": item.storeNumber,
          "Invoice Date": item.invoiceDate,
          "Invoice Due Date": item.invoiceDueDate,
          "Net Due Date": item.invoiceDueDate,
          "Downloaded": item.downloadType,
        }
      });

      var furtherInfo: Array<string> = new Array<string>();
      furtherInfo.join('info');
      this.fsInvoiceDialog.showConfirmationDialogWithFurtherInfo('Download', 'You have selected ' + this.selectedInvoices.length + ' invoice(s) for downloading `Do you wish to continue?`', furtherInfo, () => {
        this.excelService.exportAsExcelFile(newdata, 'Statement');
      }, () => {
      });
    }
  }

  async downloadClicked() {
    if (!this.isValidSelection || this.outsideDownloadRange) {
      return;
    }
    if (this.selectedKeys.length > 1350) {
      this.fsInvoiceDialog.openDialog({
        type: DialogType.ERROR,
        title: 'Export',
        content: this.selectedKeys.length + ' invoices are selected. Maximum 1350 invoices can be exported at a time.',
        actions: [
          {text: 'Ok', primary: true},
        ],
        width: 400
      }).then(r => r);
    } else {
      if (this.selectedKeys.length > 0) {
        const dialogRef = this.fsInvoiceDialog.open({
          type: DialogType.INFO,
          title: 'Available Downloads',
          content: DownloadDialogComponent,
          actions: [
            {text: 'Cancel', primary: false},
            {text: 'Download', primary: false}
          ],
          width: 400
        });

        this.invoicesString = this.selectedKeys;
        this.invoicesString = this.invoicesString.map(function (value) {
          return String(value);
        });

        this.newParents = this.selectedParents;

        let tempParents = this.newParents.toString();
        this.newParents = [tempParents];

        this.requestDownload.parents = this.newParents;
        this.requestDownload.stores = this.newStores;

        this.requestDownload.invoices = this.invoicesString;
        this.requestDownload.type = "I";
        this.requestDownload.onlyNew = false;

        const dialogContent = dialogRef.content.instance;
        dialogRef.result.subscribe((answer: any) => {
          if (answer.text === 'Download') {
            let results = dialogContent.formGroup.value;
            Object.keys(results).forEach(key => {
              if ((key === "CSV" && results[key] === true) && results["Formatted"] === false) {
                if(results["Pipe Delim"] === true) {
                  this.requestDownload.pipe = true;
                } else {
                  this.requestDownload.pipe = false;
                }
                  this.opened = true;
                  lastValueFrom(this.invoiceService.downloadCSV(this.requestDownload))
                    .then((r) => {
                      this.downloadFile(r, 'csv');
                      this.opened = false;
                    }).catch((error) => {
                    this.opened = false;
                    this._userService.showError('Problem Downloading CSV Invoice', 2000);
                    console.error(error);
                  });
              } else if ((key === "CSV" && results[key] === true) && results["Formatted"] === true) {
                this.requestDownload.pipe = results["Pipe Delim"];
                this.opened = true;
                lastValueFrom(this.invoiceService.downloadCSVFormatted(this.requestDownload))
                  .then((r) => {
                    this.downloadFile(r, 'csv');
                    this.opened = false;
                  }).catch((error) => {
                  this.opened = false;
                  this._userService.showError('Problem Downloading CSV Invoice', 2000);
                  console.error(error);
                });
              } else if (key === "XML" && results[key] === true) {
                this.opened = true;
                lastValueFrom(this.invoiceService.downloadXML(this.requestDownload))
                .then(r => {
                    this.downloadFile(r, 'xml');
                    this.loadingIndicator.hide();
                    this.opened = false;
                    this._userService.showError('Problem Downloading XML Invoice', 2000);
                });
              }
              this.selectedKeys.length = 0;
            });
          } else {
            this.opened = false;
          }
        });
      } else {
        this.fsInvoiceDialog.openDialog({
          type: DialogType.ERROR,
          title: 'Export',
          content: 'Please add at least one Invoice to export.',
          actions: [
            {text: 'Ok', primary: true},
          ],
          width: 400
        }).then(r => r);
      }
      this.masterSelect = false;
      this.opened = false;
    }
  }

  downloadFile(data: any, type: string) {
    const newBlob = new Blob([data], {type: 'application/csv'});
    const downloadURL = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    link.href = downloadURL;
    const fileName = 'invoice' + (type === 'csv' ? '.csv' : '.xml');
    link.download = fileName;
    link.click();
  }
}

